import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces/details-paginated-request'
import { getCustomerFinancials } from '../../customers'

export function useCustomerFinancials(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(
    ['customerFinancials', query],
    () => getCustomerFinancials(query)
  )
  return { data, error, isLoading }
}
